import React from 'react';

export const MeetingArrangeHeader = ({
    selectedDate,
    setSelectedDate,
    todayFormatted,
    selectedUser,
    setSelectedUser,
    userList = [],
    selectedDistrict,
    setSelectedDistrict,
    districtList = [],
    searchTerm,
    setSearchTerm,
    stats
}) => {
    return (
        <div className="p-3 border-bottom card-header bg-transparent">
            {/* Top Row: Title, Subtitle & Stats Badges */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div>
                    <h5 className="card-title mb-0 fs-16 fw-bold text-body d-flex align-items-center gap-2">
                        <i className="ri-calendar-event-fill text-info fs-18" />
                        Meeting Arrange
                    </h5>
                    <p className="text-muted fs-12 mb-0">
                        Scheduled school meetings, demonstrations, and postponed follow-ups
                    </p>
                </div>

                {/* Summary Count Badges */}
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="badge bg-soft-info text-info fs-12 px-2.5 py-1 fw-semibold">
                        Total Meetings: {stats.total}
                    </span>
                    <span className="badge bg-soft-primary text-primary fs-12 px-2.5 py-1 fw-semibold">
                        Today: {stats.today}
                    </span>
                    <span className="badge bg-soft-success text-success fs-12 px-2.5 py-1 fw-semibold">
                        Upcoming: {stats.upcoming}
                    </span>
                </div>
            </div>

            {/* Bottom Row: User Filter, Date Filter, District Filter, Search */}
            <div className="row g-2 align-items-center">
                {/* 1. Filter by Follow-up User / Staff (User requirement: follow kis user ne kiya hai) */}
                <div className="col-12 col-sm-auto">
                    <div className="d-flex align-items-center gap-1.5">
                        <span className="fs-12 text-muted fw-semibold text-nowrap">
                            <i className="ri-user-follow-line me-1" />
                            Followed By:
                        </span>
                        <select
                            className="form-select form-select-sm fs-12"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.target.value)}
                            style={{ minWidth: '145px' }}
                            title="Filter by user who made the follow-up"
                        >
                            <option value="all">All Staff / Users</option>
                            {userList.map((user) => (
                                <option key={user.id} value={user.id}>
                                    {user.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* 2. Date Filter with Today and All Dates quick actions */}
                <div className="col-12 col-md-auto d-flex align-items-center gap-1.5 flex-wrap">
                    <span className="fs-12 text-muted fw-semibold text-nowrap">
                        <i className="ri-calendar-line me-1" />
                        Meeting Date:
                    </span>
                    <input
                        type="date"
                        className="form-control form-control-sm fs-12"
                        style={{ width: 'auto', minWidth: '135px' }}
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                    <button
                        type="button"
                        className={`btn btn-sm py-1 px-2.5 fs-11 fw-medium ${selectedDate === todayFormatted ? 'btn-info text-white' : 'btn-soft-info'}`}
                        onClick={() => setSelectedDate(todayFormatted)}
                        title="Show meetings scheduled for today"
                    >
                        Today
                    </button>
                    {selectedDate && (
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-secondary py-1 px-2 fs-11"
                            onClick={() => setSelectedDate('')}
                            title="Show all meetings across all dates"
                        >
                            All Dates
                        </button>
                    )}
                </div>

                {/* 3. District Filter */}
                <div className="col-12 col-sm-auto">
                    <div className="d-flex align-items-center gap-1.5">
                        <span className="fs-12 text-muted fw-semibold text-nowrap">
                            <i className="ri-building-line me-1" />
                            District:
                        </span>
                        <select
                            className="form-select form-select-sm fs-12"
                            value={selectedDistrict}
                            onChange={(e) => setSelectedDistrict(e.target.value)}
                            style={{ minWidth: '130px' }}
                            title="Filter by school district"
                        >
                            <option value="all">All Districts</option>
                            {districtList.map((dist) => (
                                <option key={dist} value={dist}>
                                    {dist}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* 4. Live Search Input */}
                <div className="col-12 col-md ms-auto">
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control form-control-sm fs-12 ps-4"
                            placeholder="Search by school, principal, phone, remark..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-2 text-muted fs-13" />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-sm btn-link position-absolute top-50 end-0 translate-middle-y p-0 me-2 text-muted"
                                onClick={() => setSearchTerm('')}
                            >
                                <i className="ri-close-line fs-14" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeetingArrangeHeader;
